import React from "react";

const AnswersForm = ({
  answers = {},
  onChange,
  onCheckboxChange,
  namePrefix = "",
  aiMappingUpdater, // optional callback to update AI mapping
}) => {
  const handleChange = (field, value) => {
    if (onChange) onChange(field, value);
    if (aiMappingUpdater) aiMappingUpdater(field, value);
  };

  const handleCheckboxToggle = (field, value) => {
    if (onCheckboxChange) onCheckboxChange(field, value);
    if (aiMappingUpdater) aiMappingUpdater(`${field}_${value}`, !((answers[field] || []).includes(value)));
  };

  const toggleButtonStyle = (selected) => ({
    padding: "6px 12px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    cursor: "pointer",
    backgroundColor: selected ? "#4caf50" : "#fff",
    color: selected ? "#fff" : "#333",
    marginRight: "8px",
    marginBottom: "6px",
    transition: "all 0.2s",
    fontSize: "16px",
    minWidth: "80px",
    textAlign: "center",
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
      {/* 1. Pain Duration */}
      <div>
        <label style={{ fontWeight: "bold" }}>1. Started when?</label>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: "6px" }}>
          {["<1 week", "1–4 weeks", "1–3 months", ">3 months"].map((d) => (
            <button
              key={d}
              type="button"
              onClick={() => handleChange("painDuration", d)}
              style={toggleButtonStyle(answers.painDuration === d)}
            >
              {d}
            </button>
          ))}
        </div>
      </div>

      {/* 2. Pain Severity */}
      <div>
        <label style={{ fontWeight: "bold" }}>2. How Severe?</label>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: "6px" }}>
          {["Mild", "Moderate", "Severe", "Unbearable"].map((level) => (
            <button
              key={level}
              type="button"
              onClick={() => handleChange("painSeverity", level)}
              style={toggleButtonStyle(answers.painSeverity === level)}
            >
              {level}
            </button>
          ))}
        </div>
      </div>

      {/* 3. Pain Type */}
      <div>
        <label style={{ fontWeight: "bold" }}>3. Type of pain?</label>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: "6px" }}>
          {["Sharp", "Dull", "Burning", "Throbbing", "Stabbing"].map((type) => {
            const selected = Array.isArray(answers.painType) && answers.painType.includes(type);
            return (
              <button
                key={type}
                type="button"
                onClick={() => handleCheckboxToggle("painType", type)}
                style={toggleButtonStyle(selected)}
              >
                {type}
              </button>
            );
          })}
        </div>
      </div>

      {/* 4. Radiating Pain */}
      <div>
        <label style={{ fontWeight: "bold" }}>4. Pain radiates to other areas?</label>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: "6px" }}>
          {["Yes", "No"].map((option) => (
            <button
              key={option}
              type="button"
              onClick={() => handleChange("radiatingPain", option)}
              style={toggleButtonStyle(answers.radiatingPain === option)}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      {/* 5. Pain Triggers */}
      <div>
        <label style={{ fontWeight: "bold" }}>5. Pain triggers</label>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: "6px" }}>
          {["Standing", "Walking", "Sitting", "Bending", "Lifting"].map((trigger) => {
            const selected = Array.isArray(answers.triggers) && answers.triggers.includes(trigger);
            return (
              <button 
                key={trigger}
                type="button"
                onClick={() => handleCheckboxToggle("triggers", trigger)}
                style={toggleButtonStyle(selected)}
              >
                {trigger}
              </button>
            );
          })}
        </div>
      </div>

      {/* 6. Mobility Impact */}
      <div>
        <label style={{ fontWeight: "bold" }}>6. Impact on daily activities?</label>
        <div style={{ display: "flex", flexWrap: "wrap", marginTop: "6px" }}>
          {["Not much", "Somewhat", "Significantly", "Completely disabled"].map((level) => (
            <button
              key={level}
              type="button"
              onClick={() => handleChange("mobilityImpact", level)}
              style={toggleButtonStyle(answers.mobilityImpact === level)}
            >
              {level}
            </button>
          ))}
        </div>
      </div>

      {/* 7. Comments */}
      <div>
        <label style={{ fontWeight: "bold" }}>7. Comments</label>
        <textarea
          rows={4}
          style={{
            width: "100%",
            padding: "8px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "14px",
          }}
          value={answers.comments || ""}
          onChange={(e) => handleChange("comments", e.target.value)}
          placeholder="Write your comments here..."
        />
      </div>
    </div>
  );
};

export default AnswersForm;
